import React from 'react'
import {
	Button
} from 'reactstrap'

import ModalIngredientsTypesEdit from '~/modules/modals/ingredientsTypes/edit.jsx'
import ModalIngredientsTypesDelete from '~/modules/modals/ingredientsTypes/delete.jsx'


// export default class RecipeIngredientsTypesModalList extends Reflux.Component {
export default class RecipeIngredientsTypesModalListRow extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			isEditing: false
		}
	}

	toggleEdit = () => {
		this.setState({ isEditing: !this.state.isEditing })
	}

	render() {
		return (this.state.isEditing === true)
			? (
				<ModalIngredientsTypesEdit
					ingredientTypeID={this.props.ingredientTypeID}
					ingredientType={this.props.ingredientType}
					cancelFunction={this.toggleEdit}
				/>
			)
			: (
				<tr>
					<td>{this.props.ingredientType}</td>
					<td>
						<Button
							onClick={this.toggleEdit}
							color="primary"
							block
						>
							Edit
						</Button>
					</td>
					<td>
						<ModalIngredientsTypesDelete
							ingredientTypeID={this.props.ingredientTypeID}
						/>
					</td>
				</tr>
			)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/ingredientsTypes/listRow.jsx